<template>
    <div class="flex items-center gap-1" role="img" :aria-label="`Confidence level ${normalizedLevel} of 4`">
        <span v-for="index in 4" :key="index" :data-testid="`confidence-bar-${index}`" :class="barClass(index)" class="h-1.5 w-6 rounded-full" />
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
    level: number;
}

const props = withDefaults(defineProps<Props>(), {
    level: 0,
});

const normalizedLevel = computed(() => Math.min(4, Math.max(0, props.level)));

const barClass = (index: number) => (normalizedLevel.value >= index ? "bg-ink-muted" : "bg-border");
</script>
